import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/tags/:membershipGroupCardTagId/';

interface DTO {
    parkingId: string;
    membershipGroupId: number;
    membershipGroupCardTagId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, membershipGroupId, membershipGroupCardTagId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, membershipGroupId, membershipGroupCardTagId }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as DELETE_MEMBERSHIP_GROUP_CARD_TAG_RESOURCE, useMutationHook as useDeleteMembershipGroupCardTag };
export type { DTO as DeleteMembershipGroupCardTagDTO };
